































































































import { Component, Model, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import { randomId, formatPhone } from "@/utils";
import { BPopover } from "bootstrap-vue";

@Component({
  components: {
    BPopover,
  },
  filters: {
    phone: formatPhone,
  },
  computed: mapState("patients", ["phoneStatus"]),
})
export default class ConferencePopover extends Vue {
  @Model("change") readonly gap!: any;
  id = "conference-popover";
  loading = false;
  phoneStatus!: Array<any>;
  // SAME BLACKLIST THE VOICE NOTIFICATION USES: A CONFERENCE CALL IS A VOICE CALL
  invalidPhoneStatus = ["NP", "WN", "UN", "IN", "ER"];
  saved = false;
  error = null;
  // THE SERVER IS AUTHORITATIVE: THIS ONLY WARNS THE USER IN ADVANCE
  recording = false;
  get target() {
    return this.id + "-target-" + this.gap.id;
  }
  get errorMessage(): string {
    const err = this.error as any;
    return (err && err.response && err.response.data) || "COULD NOT START THE CALL";
  }
  phoneStatusName(statusId: string) {
    const status = this.phoneStatus.find((s) => s.id === statusId);
    return status ? status.name : statusId;
  }
  setPhones() {
    const { gap, invalidPhoneStatus } = this;
    gap.notifPhones = [];
    gap.notifPhone = null;
    const candidates = [
      { type: "M ", number: gap.mobilePhone, statusId: gap.mobilePhoneStatusId },
      { type: "H ", number: gap.homePhone, statusId: gap.homePhoneStatusId },
      { type: "O", number: gap.otherPhone, statusId: gap.otherPhoneStatusId },
      { type: "O", number: gap.otherPhone2, statusId: gap.otherPhone2StatusId },
    ];
    candidates.forEach((c) => {
      if (!c.number) return;
      gap.notifPhones.push({
        key: randomId(6),
        type: c.type,
        number: c.number,
        status: this.phoneStatusName(c.statusId),
        valid: !invalidPhoneStatus.includes(c.statusId),
      });
    });
    // CHECK VALID PHONES
    const validPhones = gap.notifPhones.filter((p) => p.valid);
    //
    if (validPhones.length) {
      gap.notifPhone = validPhones[0];
    } else {
      gap.notifPhone = gap.notifPhones[0];
    }
    //
  }
  async save() {
    this.loading = true;
    this.error = null;
    try {
      const { gap } = this;
      await this.$store.dispatch("notifs/startConferenceCall", {
        gapId: gap.id,
        phone: gap.notifPhone.number,
      });

      gap.subStatusId ="CMS";
      gap.subStatusName ="Comm. Sent";
      gap.subStatusBackColor ="#1660a0";
      gap.subStatusFontColor ="#FFFFFF";
      
      this.saved = true;
    } catch (error) {
      this.error = error;
    } finally {
      this.loading = false;
    }
  }
  close() {
    this.$root.$emit("bv::hide::popover", this.id);
    this.$emit("closed");
  }
  async loadConfig() {
    try {
      const config = await this.$store.dispatch("notifs/getConferenceConfig", {
        gapId: this.gap.id,
      });
      this.recording = !!config.recording;
    } catch (error) {
      // A MISSING WARNING MUST NOT BLOCK THE CALL: THE SPOKEN DISCLAIMER STILL PLAYS
    }
  }
  mounted() {
    this.setPhones();
    this.loadConfig();
  }
}
